import React from "react";

export const NotetTypeSvg = () => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.333 18.333H15a1.667 1.667 0 0 0 1.667-1.666V6.25l-4.584-4.583H5a1.667 1.667 0 0 0-1.667 1.666v3.334"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.667 1.667v5h5M2.5 12.5h5M5 10v5"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
